import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import { linReg } from '../../lib/reduce';

export const COLUMNS = (averages, images, t) => [
    {
        label: t('discover.entities.table.name'),
        key: 'name',
        data: 'name',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div>
                    <a
                        href={
                            `/domains/${window.info.id}/entities/entity?entities:in=` +
                            encodeURIComponent(data)
                        }
                    >
                        {data}
                    </a>
                </div>
            );
        },
    },
    {
        label: t('discover.entities.table.type'),
        key: 'type',
        data: 'type',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <div style={{ fontSize: '12px', textWrap: 'wrap' }}>{data}</div>;
        },
    },
    {
        label: t('discover.entities.table.pages'),
        key: 'pages',
        data: 'pages',
        Component: Cell,
    },
    {
        label: t('discover.entities.table.RELEVANCY'),
        key: 'RELEVANCY',
        data: 'RELEVANCY',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item.salience;

            let c = linReg(item.salienceL);
            let cr = c.slope >= 0 ? '+' : '-';

            return (
                <div>
                    <strong>{numeral(item.salience).format('0.00')}</strong>
                    <br />
                    {cr}
                    {numeral(Math.abs(c.slope)).format('0.0')}%
                </div>
            );
        },
    },
    {
        label: t('discover.entities.table.impressionsL'),
        key: 'impressionsL',
        data: 'impressionsL',
        infoLink: '/support/attributed-impressions',
        info: 'Attributed Impressions is own unique metric to measure entity authority on site. Click on the icon to find out more.',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return item.impressions;

            let c = linReg(data);
            let cr = c.slope >= 0 ? '+' : '-';

            return (
                <div>
                    <strong>{numeral(item.impressions).format('0.0a')}</strong>
                    <br />
                    {cr}
                    {numeral(Math.abs(c.slope)).format('0.0')}%
                </div>
            );
        },
    },
    {
        label: t('discover.entities.table.median_impressions_per_entity'),
        key: 'median_impressions_per_entity',
        data: 'median_impressions_per_entity',
        infoLink: '/support/attributed-impressions',
        info: 'Attributed Impressions is own unique metric to measure entity authority on site. Click on the icon to find out more.',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div>
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            );
        },
    },
    {
        label: t('discover.entities.table.ctr'),
        key: 'ctr',
        data: 'ctr',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;

            let c = linReg(item.ctrL);
            let cr = c.slope >= 0 ? '+' : '-';
            return (
                <div>
                    <strong>{numeral(data).format('0.0%')}</strong>
                    <br />
                    {cr}
                    {numeral(Math.abs(c.slope)).format('0.0')}%
                </div>
            );
        },
    },
    {
        label: t('discover.entities.table.strength'),
        key: 'strength',
        data: 'strength',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return getStrength(item, averages);
            return getStrength(item, averages, false, images);
        },
    },
    {
        label: t('discover.entities.table.actions'),
        key: 'actions',
        data: 'actions',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return null;
            // const trackingLink = item.mid
            //     ? `entity=${encodeURIComponent(item.mid)}&search_by=id`
            //     : `entity=${encodeURIComponent(item.name)}`;
            return (
                <div className="d-flex">
                    {/* <a
                        href={`/tools/google-discover-data/add/?${trackingLink}`}
                        className="table-action-main-btn"
                        title="Track Entity"
                        target="_blank"
                        rel="noreferrer"
                    >
                        {t('discover.entities.table.track')}
                    </a> */}
                    <a
                        title="See all connected entities"
                        href={`/domains/${window.info.id}/connected-entities/?entity=${item.name}`}
                        className="table-action-main-btn"
                        style={{ marginLeft: '12px' }}
                    >
                        {t('discover.entities.table.clusters')}
                    </a>
                </div>
            );
        },
    },
];

export const getStrength = (item, averages, isReturnNumber = true) => {
    const { avgPages, avgImpressions, avgCTR } = averages;
    const isDark = JSON.parse(localStorage.getItem('dark-mode'));

    if (
        item.pages > avgPages &&
        item.salience > 0.25 &&
        item.impressions > avgImpressions &&
        item.ctr > avgCTR
    ) {
        return isReturnNumber ? (
            3
        ) : (
            <div className="categories-strength" title="Strong">
                <img
                    src={`/static/img/categories-strength-strong${isDark ? '-dark' : ''}.svg`}
                    alt="strong"
                    loading="lazy"
                />
            </div>
        );
    } else if (
        item.pages < avgPages &&
        (item.salience > 0.25 || item.impressions < avgImpressions || item.ctr > avgCTR)
    ) {
        return isReturnNumber ? (
            2
        ) : (
            <div className="categories-strength" title="Striking Distance">
                <img
                    src={`/static/img/categories-strength-striking-distance${
                        isDark ? '-dark' : ''
                    }.svg`}
                    alt="image_striking_distance"
                    loading="lazy"
                />
            </div>
        );
    } else if (
        item.pages < avgPages &&
        item.salience < 0.25 &&
        item.impressions < avgImpressions &&
        item.ctr > avgCTR
    ) {
        return isReturnNumber ? (
            1
        ) : (
            <div className="categories-strength" title="Weak">
                <img
                    src={`/static/img/categories-strength-weak${isDark ? '-dark' : ''}.svg`}
                    alt="image_weak"
                    loading="lazy"
                />
            </div>
        );
    }
    return isReturnNumber ? 0 : null;
};
